import prt from '../Assets/Projects/prt.png';
import editor from '../Assets/Projects/codeEditor.png';
import empser from '../Assets/Projects/Empser.png';
import splash from '../Assets/Projects/Splash.jpg';
import homeMain from '../Assets/home-main.svg';
import {
  SiReact,
  SiSpringboot,
  SiJavascript,
  SiTypescript,
  SiMongodb,
  SiMysql,
  SiDocker,
  SiTailwindcss,
  SiPython,
  SiAmazon,
} from 'react-icons/si';
import { FaJava, FaServer } from 'react-icons/fa';

export const hero = {
  name: 'Prathmesh Bondar',
  role: 'Associate Software Engineer',
  tagline: 'Designing premium digital products with backend precision and frontend craft.',
  description:
    'I build scalable APIs, modern full-stack products, and performance-first experiences with clean engineering fundamentals and polished UI execution.',
  image: homeMain,
  stats: [
    { label: 'Production Projects', value: '12+' },
    { label: 'Professional Experience', value: '1+ Years' },
    { label: 'Core Focus', value: 'Java + React' },
  ],
};

export const projects = [
  {
    title: 'Startify Job Aggregator',
    description:
      'A full-stack job discovery platform with multi-source aggregation, smart filters, and user-friendly search workflows.',
    image: prt,
    tech: ['React', 'Spring Boot', 'MongoDB', 'Docker', 'REST API'],
    liveUrl: 'https://your-job-aggregator.vercel.app',
    repoUrl: 'https://github.com/Prathmesh3177/Job-aggregator',
    size: 'md:col-span-2 md:row-span-2',
  },
  {
    title: 'Credit Default Prediction',
    description:
      'ML-assisted risk intelligence with API-driven scoring and dashboard-ready outputs for credit operations.',
    image: editor,
    tech: ['Python', 'Flask', 'React', 'Random Forest', 'MongoDB'],
    liveUrl: '',
    repoUrl: 'https://github.com/Prathmesh3177',
    size: 'md:col-span-1 md:row-span-1',
  },
  {
    title: 'Employee Management System',
    description:
      'Robust HR operations suite with modular backend architecture and secure CRUD flows.',
    image: empser,
    tech: ['React', 'Spring Boot', 'MySQL', 'REST API'],
    liveUrl: '',
    repoUrl: 'https://github.com/Prathmesh3177/Employee-management-system.git',
    size: 'md:col-span-1 md:row-span-1',
  },
  {
    title: 'College Finder Engine',
    description:
      'Profile-matching recommendation engine for students, including institute comparison and eligibility logic.',
    image: splash,
    tech: ['Java', 'JavaFX', 'OOP', 'Recommendation Logic'],
    liveUrl: '',
    repoUrl: 'https://github.com/Prathmesh3177/College-Finder.git',
    size: 'md:col-span-1 md:row-span-1',
  },
  {
    title: 'Electricity Billing System',
    description:
      'Automated billing system for meter tracking, customer records, and invoice generation pipelines.',
    image: editor,
    tech: ['Java', 'JDBC', 'SQL'],
    liveUrl: '',
    repoUrl: 'https://github.com/Prathmesh3177/Electricity-Billing-System.git',
    size: 'md:col-span-2 md:row-span-1',
  },
];

export const skillGroups = [
  {
    title: 'Frontend',
    items: [
      { name: 'React', icon: SiReact },
      { name: 'JavaScript', icon: SiJavascript },
      { name: 'TypeScript', icon: SiTypescript },
      { name: 'Tailwind', icon: SiTailwindcss },
    ],
  },
  {
    title: 'Backend',
    items: [
      { name: 'Java', icon: FaJava },
      { name: 'Spring Boot', icon: SiSpringboot },
      { name: 'REST APIs', icon: FaServer },
      { name: 'Python', icon: SiPython },
    ],
  },
  {
    title: 'Data & DevOps',
    items: [
      { name: 'MongoDB', icon: SiMongodb },
      { name: 'MySQL', icon: SiMysql },
      { name: 'Docker', icon: SiDocker },
      { name: 'Cloud Basics', icon: SiAmazon },
    ],
  },
];

export const experiences = [
  {
    period: '2024 - Present',
    title: 'Associate Software Engineer',
    company: 'Product Engineering',
    summary:
      'Driving backend-heavy features and full-stack delivery with production quality standards.',
    points: [
      'Built and maintained scalable API services with clear service boundaries.',
      'Improved delivery speed through reusable modules and engineering standards.',
      'Collaborated across frontend and backend for end-to-end releases.',
    ],
  },
  {
    period: '2023 - 2024',
    title: 'Full-Stack Project Builder',
    company: 'Independent + Academic',
    summary:
      'Shipped practical products across hiring, analytics, education, and operations domains.',
    points: [
      'Developed production-minded apps with React and Java ecosystems.',
      'Applied data modeling and clean architecture to reduce complexity.',
      'Focused on maintainability, responsiveness, and testable system design.',
    ],
  },
  {
    period: 'Core Philosophy',
    title: 'Engineer Mindset',
    company: 'How I Work',
    summary:
      'I treat UX quality and system reliability as equal priorities.',
    points: [
      'Build for long-term maintainability and measurable outcomes.',
      'Balance speed with correctness and production-readiness.',
      'Prefer clear architecture, strong defaults, and thoughtful details.',
    ],
  },
];

export const socialLinks = [
  { label: 'GitHub', url: 'https://github.com/Prathmesh3177' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/prathamesh-bondar-57216a2a5/' },
  { label: 'Instagram', url: 'https://www.instagram.com/r_a_n_cho?igsh=OG1yd2M5cGlsanYz&utm_source=qr' },
];

export const contact = {
  email: 'prathmeshbondar3177@gmail.com',
  location: 'India',
  availability: 'Open for impactful engineering roles and high-value product collaborations.',
};

export const marquee = [
  'Backend Engineering',
  'Premium Frontend UX',
  'Scalable API Design',
  'Performance-first React',
  'Modern Java Systems',
  'Product Craftsmanship',
  'Backend Engineering',
  'Premium Frontend UX',
  'Scalable API Design',
  'Performance-first React',
  'Modern Java Systems',
  'Product Craftsmanship',
];
